import { useEffect } from "react";

/** Redirige al landing estático "Business Relief" servido desde /public. */
const BusinessReliefRedirect = () => {
  useEffect(() => {
    window.location.replace("/business_relief.html");
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0a0a14",
      color: "#C9A84C",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }} data-testid="business-relief-loading">
      Cargando…
    </div>
  );
};

export default BusinessReliefRedirect;
